import { User } from '../shared/types/User';

type UserIdentity = {
  userId: string;
  userName: string;
  email: string;
};

const normalizeUser = (user: User): UserIdentity | null => {
  if (!user) return null;

  const name = user.fullName || (user.firstName || '') + ' ' + (user.lastName || '');
  const email = user.email || '';

  return {
    userId: String(user.userId || ''),
    userName: String(name || ''),
    email: String(email || ''),
  };
};

export const setAppDynamicsIdentity = (user: User | null) => {
  if (!user) return;

  const normalizedUserInfo = normalizeUser(user);

  // Update FN_CONFIG.APPD_CONFIG.user instead of APPD_CONFIG.user
  const FN_CONFIG = (window as any).FN_CONFIG;
  if (FN_CONFIG?.APPD_CONFIG) {
    FN_CONFIG.APPD_CONFIG.user = normalizedUserInfo;
  }

  if (window.setIdentity) {
    window.setIdentity(normalizedUserInfo);
  }
};

export const clearAppDynamicsIdentity = () => {
  if (window.clearIdentity) {
    window.clearIdentity();
  }

  // Update FN_CONFIG.APPD_CONFIG.user instead of APPD_CONFIG.user
  const FN_CONFIG = (window as any).FN_CONFIG;
  if (FN_CONFIG?.APPD_CONFIG) {
    FN_CONFIG.APPD_CONFIG.user = null;
  }
};

export const logAppDynamicsEvent = (eventName: string, eventData?: Record<string, unknown>) => {
  if (window.waitForADRUM && window.ADRUM?.command) {
    window.waitForADRUM(() => {
      try {
        if (eventData && typeof eventData === 'object') {
          Object.entries(eventData).forEach(([k, v]) => {
            window.ADRUM?.command?.('addUserData', `evt.${k}`, String(v as any));
          });
        }
        window.ADRUM?.command?.('addUserData', 'evt.Name', String(eventName));
        window.ADRUM?.command?.('sendBeacon');
      } catch (err) {
        if (
          typeof process !== 'undefined' &&
          process.env &&
          process.env.NODE_ENV !== 'production' &&
          typeof console !== 'undefined' &&
          typeof console.error === 'function'
        ) {
          console.error('AppDynamics event logging error:', err);
        }
      }
    });
  }
};
